module.exports = __webpack_public_path__ + "static/poster-mob-57bdaa43bc6249348ffc13cf583ab60b.jpg";